<div class="dialog">
  <lucide-icon name="x" class="dialog-close" (click)="onClose()" [size]="20"></lucide-icon>

  <div class="dialog-header">
    <lucide-icon name="user-pen" class="user-icon" [size]="20"></lucide-icon>
    <div class="dialog-title">{{ dialogTitle }}</div>
  </div>

  <form [formGroup]="formGroup" class="dialog-body">
    <div class="form-field">
      <label
        >{{ 'userManagementPage.usersPage.inviteUserEmailTitle' | labelsProvider }}
        <span class="required">*</span></label
      >
      <input
        class="text-input"
        type="text"
        [placeholder]="'userManagementPage.usersPage.inviteUserEmailPlaceholder' | labelsProvider"
        formControlName="userEmail"
        [readonly]="isEditMode"
      />
    </div>

    @if (details.authentications.length > 1 && !isEditMode) {
      <div class="form-field">
        <label
          >{{ 'userManagementPage.usersPage.authenticationTitle' | labelsProvider }}
          <span class="required">*</span></label
        >
        <mat-form-field appearance="outline" class="w-100">
          <mat-select
            [placeholder]="'userManagementPage.usersPage.authenticationPlaceholder' | labelsProvider"
            formControlName="authentication_id"
            panelClass="user-dialog-select-panel"
          >
            @for (auth of authentications; track auth.id) {
              <mat-option [value]="auth.id">{{ auth.displayName }}</mat-option>
            }
          </mat-select>
        </mat-form-field>
      </div>
    }

    <div class="form-field">
      <label>{{ 'userManagementPage.usersPage.userIsAdminLabel' | labelsProvider }}</label>
      <div class="admin-toggle-row">
        <span class="admin-description">{{
          'userManagementPage.usersPage.userIsAdminDescription' | labelsProvider
        }}</span>
        <mat-slide-toggle formControlName="isAdmin" color="primary"></mat-slide-toggle>
      </div>
    </div>

    <div class="form-field" *ngIf="!formGroup.get('isAdmin')?.value">
      <label>{{ 'userManagementPage.usersPage.assignToAccessGroupLabel' | labelsProvider }}</label>
      <app-multi-select
        class="projects-select"
        [options$]="accessGroupOptions$"
        [selectedIds]="selectedAccessGroupIds"
        [withSearch]="true"
        [placeHolder]="'userManagementPage.usersPage.selectAccessGroupsPlaceholder' | labelsProvider"
        (optionOnSelection)="onAccessGroupSelected($event)"
      >
      </app-multi-select>
    </div>
  </form>

  <div class="dialog-footer">
    <button type="button" class="btn btn-secondary" (click)="onClose()">
      {{ 'common.cancel' | labelsProvider }}
    </button>
    <button
      type="button"
      class="btn btn-primary"
      [disabled]="formGroup.invalid || waitingForResponse || !hasChanges"
      (click)="submit()"
    >
      @if (!waitingForResponse) {
        <span>{{ submitButtonText }}</span>
      } @else {
        <mat-progress-spinner class="spinner" color="primary" mode="indeterminate"></mat-progress-spinner>
      }
    </button>
  </div>
</div>
